export default "__VITE_ASSET__Cb8FQ186__"